{
  "form": {
    "appendOnly": "La versión actual no se elimina. Lo que guarde se convierte en una nueva versión, y ambas permanecen en la historia clínica junto con quién las escribió.",
    "requiredHint": "Los campos sin indicación son obligatorios.",
    "optional": "opcional",
    "save": "Guardar",
    "saving": "Guardando …",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "discardQuestion": "¿Cerrar el formulario? Lo que ha escrito no se guardará.",
    "discardConfirm": "Cerrar sin guardar",
    "discardCancel": "Seguir rellenando"
  },
  "notAnswered": "No consta",
  "section": {
    "heading": "Documentar y modificar alergias y alertas",
    "allergiesHeading": "Datos de alergia en la historia clínica",
    "flagsHeading": "Alertas en la historia clínica",
    "noAllergies": "No hay datos de alergia en la historia clínica.",
    "noFlags": "No hay alertas en la historia clínica."
  },
  "allergy": {
    "headingDocument": "Documentar alergia",
    "headingCorrect": "Modificar dato de alergia",
    "openDocument": "Documentar alergia",
    "openCorrect": "Modificar alergia",
    "openCorrectNamed": "Modificar alergia: {substance}",
    "explanationDocument": "Para una alergia o hipersensibilidad que no figura en la historia clínica. La sustancia se muestra en la parte superior del resumen del paciente, sin necesidad de desplazarse.",
    "explanationCorrect": "Para un dato de alergia que es erróneo. Elija Retirado (por error) si el dato no debería haberse documentado nunca.",
    "savedDocument": "La alergia está documentada.",
    "savedCorrect": "El cambio está guardado.",
    "fieldStatus": "Estado",
    "fieldSubstance": "Sustancia",
    "fieldReaction": "Reacción",
    "fieldSeverity": "Gravedad",
    "fieldCriticality": "Riesgo ante nueva exposición",
    "fieldVerification": "Confirmada",
    "hintStatus": "Elija Sin alergias conocidas cuando se ha preguntado y la respuesta es no. Es un dato de la historia clínica, no una lista vacía.",
    "hintSubstance": "Medicamento, sustancia o alimento, con la denominación que se usa aquí. El texto no se traduce nunca.",
    "hintReaction": "Qué ocurrió con la exposición.",
    "hintSeverity": "Déjelo vacío si la gravedad no se ha evaluado. Vacío no significa leve.",
    "hintCriticality": "Qué peligro se estima que tiene una nueva exposición. No es lo mismo que la gravedad de la reacción.",
    "hintVerification": "Déjelo vacío si no se ha evaluado.",
    "statusActive": "Activa",
    "statusResolved": "Resuelta",
    "statusNoKnownAllergies": "Sin alergias conocidas",
    "statusEnteredInError": "Retirado (por error)",
    "verificationConfirmed": "Confirmada",
    "refusal": {
      "statusInvalid": "No se reconoce el estado. La alergia no se ha guardado.",
      "statusNotAllowed": "Retirado (por error) no puede elegirse para un dato nuevo: un dato que no debe existir no se documenta. La alergia no se ha guardado.",
      "substanceMissing": "Debe indicarse la sustancia. La alergia no se ha guardado.",
      "substanceNotAllowed": "Sin alergias conocidas no puede combinarse con una sustancia. Elimine la sustancia o elija otro estado. La alergia no se ha guardado.",
      "severityInvalid": "No se reconoce la gravedad. La alergia no se ha guardado.",
      "criticalityInvalid": "No se reconoce el riesgo ante nueva exposición. La alergia no se ha guardado.",
      "verificationInvalid": "No se reconoce el valor de Confirmada. La alergia no se ha guardado.",
      "notFound": "El dato de alergia no figura en la historia clínica. El cambio no se ha guardado. Vuelva a abrir el resumen del paciente.",
      "retracted": "El dato de alergia está retirado en la historia clínica y no puede modificarse. El cambio no se ha guardado. Si es necesario, documente un dato nuevo.",
      "unknown": "La alergia no se ha guardado. Inténtelo de nuevo."
    }
  },
  "flag": {
    "headingDocument": "Documentar alerta",
    "headingCorrect": "Modificar alerta",
    "openDocument": "Documentar alerta",
    "openCorrect": "Modificar alerta",
    "openCorrectNamed": "Modificar alerta: {type}",
    "explanationDocument": "Para aislamiento, riesgo de contagio, riesgo de caídas, peso o estado de alergia no evaluado. DNR y limitación del esfuerzo terapéutico no pueden documentarse aquí: requieren que conste en la historia clínica quién tomó la decisión y cuándo.",
    "explanationCorrect": "Para una alerta que es errónea. El tipo no puede modificarse; elija Retirado (por error) si la alerta no debería haberse documentado nunca.",
    "savedDocument": "La alerta está documentada.",
    "savedCorrect": "El cambio está guardado.",
    "correctExisting": "Modificar la existente",
    "fieldType": "Tipo de alerta",
    "fieldStatus": "Estado",
    "fieldValue": "Dato",
    "fieldWeight": "Peso en kilogramos",
    "fieldIsolationType": "Tipo de aislamiento",
    "fieldLimitation": "La limitación, en breve",
    "fieldNote": "Justificación",
    "hintType": "El tipo no puede modificarse después. Una alerta de tipo erróneo debe retirarse y documentarse de nuevo.",
    "hintStatus": "Elija Resuelta cuando la alerta ya no sea aplicable, y Retirado (por error) solo cuando no debería haberse documentado nunca.",
    "hintWeight": "Escriba el peso con punto decimal: 62.4. No se acepta la coma.",
    "hintIsolationType": "Por ejemplo droppsmitta o luftsmitta, con la denominación que se usa aquí.",
    "hintLimitation": "Una línea. La justificación se escribe en el campo de abajo.",
    "hintNote": "Los antecedentes de la alerta.",
    "statusActive": "Activa",
    "statusResolved": "Resuelta",
    "statusEnteredInError": "Retirado (por error)",
    "refusal": {
      "typeInvalid": "No se reconoce el tipo de alerta. La alerta no se ha guardado.",
      "typeNotDocumentable": "{type} no puede documentarse aquí: la historia clínica exige que conste quién tomó la decisión y cuándo, y eso no puede indicarse en esta versión. La alerta no se ha guardado.",
      "typeNotDocumentableUnnamed": "Este tipo de alerta no puede documentarse aquí: la historia clínica exige que conste quién tomó la decisión y cuándo, y eso no puede indicarse en esta versión. La alerta no se ha guardado.",
      "statusInvalid": "No se reconoce el estado. La alerta no se ha guardado.",
      "statusNotAllowed": "Retirado (por error) no puede elegirse para una alerta nueva: una alerta que no debe existir no se documenta. La alerta no se ha guardado.",
      "valueMissing": "Debe indicarse el dato para este tipo de alerta. La alerta no se ha guardado.",
      "weightMissing": "Debe indicarse el peso. Un peso sin valor es peor que ningún peso: se interpreta como si la pregunta estuviera respondida. La alerta no se ha guardado.",
      "isolationTypeMissing": "Debe indicarse el tipo de aislamiento. La alerta no se ha guardado.",
      "weightComma": "Escriba el peso con punto decimal: 62.4, no 62,4. La alerta no se ha guardado.",
      "weightMalformed": "El peso no se reconoce como un número. Escríbalo con cifras y punto decimal: 62.4. La alerta no se ha guardado.",
      "weightNotPositive": "El peso debe ser mayor que cero. La alerta no se ha guardado.",
      "alreadyDocumented": "El paciente ya tiene una alerta de tipo {type}. Modifique esa: es la que se muestra en el resumen. No se ha guardado ninguna alerta nueva.",
      "alreadyDocumentedUnnamed": "El paciente ya tiene una alerta de ese tipo. Modifique esa: es la que se muestra en el resumen. No se ha guardado ninguna alerta nueva.",
      "notFound": "La alerta no figura en la historia clínica. El cambio no se ha guardado. Vuelva a abrir el resumen del paciente.",
      "retracted": "La alerta está retirada en la historia clínica y no puede modificarse. El cambio no se ha guardado. Si es necesario, documente una alerta nueva.",
      "unknown": "La alerta no se ha guardado. Inténtelo de nuevo."
    }
  },
  "refusal": {
    "fieldTooLong": "{field} es demasiado largo. Máximo {maximum} caracteres. No se ha guardado nada.",
    "versionStale": "Otra persona ha guardado una nueva versión mientras el formulario estaba abierto. Vuelva a abrir el resumen del paciente y compruebe lo que figura. Lo que ha escrito no se ha guardado.",
    "noChange": "No hay cambios respecto a la historia clínica. No se ha escrito ninguna versión nueva.",
    "supersedesWrong": "El formulario y la historia clínica no coinciden en la versión de partida. Cierre el resumen del paciente y vuelva a abrirlo. No se ha guardado nada.",
    "patientNotFound": "El paciente no figura en la historia clínica. No se ha guardado nada.",
    "patientRetracted": "El paciente está retirado en la historia clínica. No se ha guardado nada.",
    "roleMayNotDocument": "Su rol no permite documentar en la historia clínica. No se ha guardado nada.",
    "unavailable": "Sin conexión con el servidor. No se ha guardado nada: deje el formulario abierto e inténtelo de nuevo."
  }
}
